import React from 'react';
import {TableHead,TableRow,TableCell, makeStyles} from '@material-ui/core';
import TableHeaderSortButton from '../../common/TableHeaderSortButton';
import ActionsContextV2 from '../ActionsContextV2';
import styled from 'styled-components';

const ActionFormApprovedGroupHeaderV2 = ({currentStepIndex,readOnly}) => {

    const titleProperties = [
        { 
            title:"Approval Type",
            property: "approvalType"
        },
        { 
            title:"SDN",
            property: "procedureSdn"
        },
        { 
            title:"Title",
            property: "procedureName"
        },
        { 
            title:"Category",
            property: "categoryName"
        },        
        {  
            title:"Rev",
            property: "rev"
        },
        {  
            title:"*Comply as-is?",
            property: "applicability"
        },
        {  
            title:"Reasoning",
            property: "deviationReasoning",
            hideForReadOnly: true
            
        },
        {  
            title:"Status",
            property: "statusAction",
            hideForLevel1:true,
        },
        {  
            title:"Comment",
            property: "comments",
            // hideForReadOnly: true

        },
    ]

    const useStyles = makeStyles({
        head: {
            position: "sticky",
            top: 10,
        },
    });

    const context = React.useContext(ActionsContextV2);
    const classes = useStyles();

    return (
            <TableHead>
                <TableRow >
                {titleProperties.map((titleProperty,index) => (
                   ((titleProperty.hideForReadOnly && readOnly) || (titleProperty.hideForLevel1 && currentStepIndex === 0)) ? null :
                <TableCell key={index}>
                    <div style={index === 0 ? {paddingLeft:20, minWidth:174} : 
                        index === 1 ? {minWidth:200} :
                        index === 2 ? {minWidth:312} :
                        index === 3 ? {minWidth:130} :
                        index === 4 ? {minWidth:110} :
                        index === 5 ? {minWidth:150} :
                        index === 6 ? {minWidth:126} :
                        index === 7 ? {minWidth:100} :
                        index === 8 ? {minWidth:115} :
                    {}}>
                    <TableHeaderSortButton 
                            title={titleProperty.title}
                            property={titleProperty.property}
                            propertyToSortBy={context.actionsRedux.pendingSortProperty}
                            sortReverse={context.actionsRedux.pendingSortReverse}
                            onClick={property=>{context.setPendingSortProperty(property)}}
                    />
                    </div>
                </TableCell>))}
                {(context.editAlternateSdn && !context.alternateSdnAction ) && <TableCell/>}
                </TableRow>
            </TableHead>
    );
   

}

export default ActionFormApprovedGroupHeaderV2;